// extracted by mini-css-extract-plugin
export default {"formField":"xNHabv9k6qZh96cLl_sa","column":"ztxLnLPFAfX1Z5k4ifCM","billingDetails":"y8phwuRbE_XX6waqEGwK"};